/* eslint-disable jsx-a11y/anchor-is-valid */
import { Row, Col, Button, Radio, message, Spin, Menu, Table, Space, Input } from 'antd';
import React, { useEffect } from 'react';
import Card from '../../CardList/Card';
import { bluethoothEnviroment } from '../../Device/Simulator/Bluethooth';
import { SMART_LOCK_AUTH_MODE } from '../../Device/Simulator/IOT';
import FingerPrint from '../../FingerPrints';
import PasswordKeyboard from '../../PasswordKeyboard/PasswordKeyboard';
import BlueTooth from './BluetoothButton';

const configIndexes = [1, 2, 3, 4, 5];

export const SmartLockConfig = (props) => {
    const { device, mode: authMode, version, setVersion } = props;
    const { MACAddress } = device;

    const currentDevice = bluethoothEnviroment.getDeviceByMAC(MACAddress);

    const [mode, setMode] = React.useState('指纹');
    const [password, setPassword] = React.useState('');
    const [fingerprint, setFingerprint] = React.useState(1);
    const [selectedCard, setSelectedCard] = React.useState(1);

    const updatePassword = (value) => {
        if (value && value.length > 6) {
            return;
        }

        setPassword(value);
    };

    const onSelected = (item) => {
        setFingerprint(item);
    };

    const handleCardClick = (index) => {
        setSelectedCard(index);
    };

    const checkData = () => {
        let data = ''
        switch (mode) {
            case '指纹':
                if (!fingerprint) {
                    message.error('请选择指纹');
                    return;
                }
                data = fingerprint;
                break;
            case '密码':
                if (!password || password.length !== 6) {
                    message.error('请输入6位数字密码');
                    return;
                }

                // 校验密码是否为6位数字
                const reg = /^\d{6}$/;
                if (!reg.test(password)) {
                    message.error('请输入6位数字密码');
                    return;
                }

                data = password;
                break;
            case '卡片':
                if (!selectedCard) {
                    message.error('请选择卡片');
                    return;
                }
                data = selectedCard;
                break;
            default:
                break;
        }

        return data;
    }

    const registryAuth = () => {
        let data = checkData(mode);
        if (!data) return;

        try {
            currentDevice.registerAuth(mode, data);
        } catch (e) {
            console.error(e)
            message.error(e.message);
            return;
        }

        message.success('注册成功');
        setVersion();
    }

    const verifyAuth = () => {
        let result = false;
        let data = checkData(mode);
        if (!data) return;

        try {
            result = currentDevice.verifyAuth(mode, data);
        } catch (e) {
            console.error(e)
            message.error(e.message);
            return;
        }

        if (result) {
            message.success('验证成功， 门锁已打开');
        } else {
            message.error('验证失败');
        }

        setVersion();
    }

    return (
        <div
        key={version}
        style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            flexDirection: 'column',
        }}>     
           {/* 提供三种验证方式：指纹、密码、卡片 */}
            <div style={{ width: '100%' }}>
                <div
                    style={{ 
                        width: '100%',
                        marginTop: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center' 
                    }}
                >
                    <Radio.Group
                        value={mode}
                        buttonStyle="solid"
                        onChange={(e) => {
                            setMode(e.target.value);
                        }}
                    >
                        <Radio.Button value="指纹">指纹</Radio.Button>
                        <Radio.Button value="密码">密码</Radio.Button>
                        <Radio.Button value="卡片">卡片</Radio.Button>
                    </Radio.Group>
                </div>
                    
                <div
                    style={{ 
                        width: '100%',
                        marginTop: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center' 
                    }}
                >
                {
                    mode === '指纹' ? (
                        <Row align='center' justify="space-around">
                            {
                                configIndexes.map((item) => {
                                    const selected = fingerprint === item;

                                    return (
                                        <Col span={4} key={item}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                margin: '10px',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                            }}>
                                                <div style={{ fontSize: '14px', marginBottom: '10px' }}>{item}号</div>
                                                <FingerPrint color="rgb(153 153 160)" size={100} selected={selected} onSelected={() => onSelected(item)} />
                                            </div>
                                        </Col>
                                    );
                                })  
                            }
                            </Row>
                    ) : null
                }

                {
                    mode === '密码' ? (
                        <div style={{ width: '100%' }}>
                            <Row align="middle" style={{ marginBottom: '10px' }}>
                                <Col span={4}>
                                    <div style={{ fontSize: '14px' }}>请输入6位数字密码：</div>
                                   </Col>
                                <Col span={16}>
                                <Input
                                    style={{ width: '100%' }}
                                    value={password}
                                    onChange={(e) => updatePassword(e.target.value)}
                                />
                                </Col>
                            </Row>

                            <PasswordKeyboard
                                password={password}
                                onKeyPress={updatePassword}
                            />
                        </div>
                    ) : null
                }

                {
                    mode === '卡片' ? (
                        <div style={{ width: '100%' }}>
                            <Row justify="space-around">
                            {
                                configIndexes.map((card, index) => (
                                    <Col span={4} key={index}>
                                        <Card
                                            key={index}
                                            title={`${card}号`}
                                            selected={selectedCard === card}
                                            onClick={() => handleCardClick(card)}
                                        />
                                    </Col>
                                ))
                            }
                            </Row>
                        </div>
                    ) : null
                }

                </div>
            </div>

            {/* 确认按钮 */}
            <div
                style={{ 
                    width: '100%',
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center' 
                }}
            >
                <div style={{ fontSize: '14px', marginBottom: '10px' }}>
                    <Button
                        type="primary"
                        style={{ width: '150px', height: '36px', fontSize: '18px' }}
                        onClick={() => {
                            switch (authMode) {
                                case SMART_LOCK_AUTH_MODE.REGISTER:
                                    registryAuth();
                                    break;
                                case SMART_LOCK_AUTH_MODE.VERIFY:
                                    verifyAuth();
                                    break;
                                default:
                                    break;
                            }
                        }}
                    >
                        确认
                    </Button>
                </div>
            </div>
        </div>
    );
};

const SmartLockAuthRecords = (props) => {
    const { device, state = {}, setVersion } = props;
    const { authRecords = [] } = state;
    
    return (
        <div>
            <div>
                <div style={{ fontSize: '14px', marginBottom: '10px' }}>验证记录</div>
                <div style={{ width: '100%' }}>
                    <Table
                        dataSource={authRecords}
                        rowKey={(record) => {
                            return `${record.type}-${record.data}`;
                        }}
                        columns={[
                            {
                                title: '验证方式',
                                dataIndex: 'type',
                                key: 'type',
                            },
                            {
                                title: '验证数据',
                                dataIndex: 'data',
                                key: 'data',
                            },
                            {
                                title: '操作',
                                render: (text, record) => {
                                    return (
                                        <Space size="middle">
                                            <a
                                                onClick={() => {
                                                    try {
                                                        device.deleteAuth(text.type, text.data);
                                                        setVersion();
                                                    } catch (e) {
                                                        message.error(e.message);
                                                    }
                                                }}
                                            >
                                               删除
                                            </a>
                                        </Space>
                                )}
                            }
                        ]}
                    />
                    
                    </div>
            </div>
        </div>
    );
};

const ManagePage = (props) => {
    const { version, state = {} } = props;
    const { lockStatus } = state;
    
    if (lockStatus) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '20px', height: '300px' }}>
                请先解锁，再进行注册。默认为密码验证，默认密码为888888
            </div>
        );
    }

    return (
        <div key={version}>
            <SmartLockConfig {...props} mode={SMART_LOCK_AUTH_MODE.REGISTER} />
            <div style={{ width: '100%', height: '1px', background: '#e8e8e8', margin: '10px 0' }} />
            <SmartLockAuthRecords {...props} />
        </div>
    );
};


function SmartLock (props) {
    const { device, onClose } = props;

    const [state, setState] = React.useState(null);
    const [version, setVersion] = React.useState(1);
    const [current, setCurrent] = React.useState('verify');

    const setCurrentVersion = () => {
        setVersion(version + 1);
    }

    useEffect(() => {
        const data = device.getValues();
        setState(data);
    }, [device, version]);

    if (!state) {
        return <Spin />;
    }

    // console.log(device, state, 'state')

    const menus = [
        {
            title: '验证',
            value: 'verify',
        },
        {
            title: '管理',
            value: 'manage',
        },
    ];

    return (
        <div>
            <style>
                {
                    `
                    .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected {
                        background-color: #fff !important;
                        color: rgba(0, 0, 0, 0.85);
                    }
                    `
                }
            </style>

            <div style={{ position: 'absolute', top: '10px', right: '80px' }}>
                <BlueTooth device={device} onClose={onClose} />
            </div>
           

           <div style={{ width: '100%' }}>
            <Menu
                onClick={(e) => {
                    setCurrent(e.key);
                }}
                mode="horizontal"
                selectedKeys={[current]}
            >
                {
                    menus.map((item) => {
                        const { title, value } = item;

                        return (
                            <Menu.Item key={value}>
                                <div style={{ fontSize: '14px', marginBottom: '10px' }}>{title}</div>
                            </Menu.Item>
                        );
                    })
                }
            </Menu>
            {
                current === 'verify' ? (
                    <SmartLockConfig device={device} state={state} version={version} mode={SMART_LOCK_AUTH_MODE.VERIFY} onClose={onClose} setVersion={setCurrentVersion} />
                ) : null
            }

            {
                current === 'manage' ? (
                    <ManagePage version={version} device={device} state={state} onClose={onClose} setVersion={setCurrentVersion} />
                ) : null
            }
           </div>
        </div>
    );
}

export default SmartLock;